import { Checkbox, FormControlLabel, FormGroup, Grid, TextField } from "@mui/material";
import { AppFrame } from "../components/AppFrame"
import { BottomNav } from "../components/BottomNav";
import { EnterDimFrame } from "../components/EnterDimFrame";
import { useNavigate } from "react-router-dom";
import logo from '../images/SensorSetupWarning.png';


export const SensorSetupWarning = () => {

    const navigate = useNavigate();

    const onClickPrev = () => {
        navigate(-1)
    }

    const onClickNext = () => {
        navigate("/machinePositioning")
    }

    return (
        <AppFrame>
            <EnterDimFrame logo={logo} instruction="Stellen Sie sicher, dass die Einrichtung der Sensoren erfolgt ist!">
                <Grid container spacing={4}>
                    <Grid item xs={4}>

                    </Grid>
                    <Grid item xs={4} >
                        <FormGroup >
                            <FormControlLabel control={<Checkbox defaultChecked={false} />} label="Einrichtung Sensoren durchgeführt" />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={4}>

                    </Grid>
                </Grid>

            </EnterDimFrame>
            <BottomNav onClickPrev={onClickPrev} onClickNext={onClickNext} />

        </AppFrame>
    )
}

/*<h4>Anzahl der Zylinder und Umfänge eingeben</h4>
        <img  src={mainLogo} alt="fireSpot" height={180}/>
        <TextField id="outlined-basic" label="Anzahl Zylinder" variant="outlined" sx={{marginTop: 2}}/>
        <TextField id="outlined-basic" label="U1 [cm]" variant="outlined"  sx={{marginTop: 2}}/>
        <TextField id="outlined-basic" label="U2 [cm]" variant="outlined"  sx={{marginTop: 2}}/> */